module.exports = __webpack_public_path__ + "static/media/health-insurance.c68addde.jpg";